export const timelineFormatExample = `[
  {
    "label": "George Washington",
    "startTime": "1789-04-30T12:00:00Z",
    "endTime": "1797-03-04T12:00:00Z"
  },
  {
    "label": "John Adams",
    "startTime": "1797-03-04T12:00:00Z",
    "endTime": "1801-03-04T12:00:00Z"
  }
]`;
